export default __webpack_public_path__ + "static/media/2526 knife block B top.a684b7cc.png";